import React from "react";
import Invitation from "./Invitation";

export const invitationRoute = () => [
  {
    path: "/invitation/:orgId/:code",
    title: "invitation",
    component: Invitation,
  },
];
